<template>
  <div class="applyPage" v-loading="loading">
    <backgroundTop title="遵义医科大学附属医院"></backgroundTop>
    <el-steps :active="stepIndex" finish-status="success" simple style="margin-top: -50px">
      <el-step title="选择招聘岗位"></el-step>
      <el-step title="填写招聘信息"></el-step>
      <el-step title="信息审核"></el-step>
      <el-step title="网上缴费"></el-step>
      <el-step title="缴费审核"></el-step>
      <el-step title="完成报名"></el-step>
    </el-steps>
    <div class="stepPage">
      <div v-if="stepIndex == 0">
        <ApplyInfo></ApplyInfo>
      </div>
      <div v-if="stepIndex == 1">
        <ApplyForm></ApplyForm>
      </div>
      <div v-if="stepIndex == 2">
        <ApplyAudit></ApplyAudit>
      </div>
      <div v-if="stepIndex == 3">
        <ApplyPay></ApplyPay>
      </div>
      <div v-if="stepIndex == 4">
        <ApplyPayCheck></ApplyPayCheck>
      </div>
      <div v-if="stepIndex == 5">
        <ApplyPlan></ApplyPlan>
      </div>
      <div v-if="stepIndex == 6">
        <ApplySuccess></ApplySuccess>
      </div>
      
    </div>
    <CopyRight></CopyRight>
  </div>
</template>
<script>
import backgroundTop from '../components/backgroundTop'
import ApplyInfo from './ApplyInfo'
import ApplyForm from './ApplyForm'
import ApplyAudit from './ApplyAudit'
import ApplyPay from './ApplyPay'
import ApplySuccess from './ApplySuccess'
import ApplyPayCheck from './ApplyPayCheck'
import ApplyPlan from './ApplyPlan'
import CopyRight from '../components/CopyRight'
import { mapState, mapMutations } from 'vuex'
export default {
  components: {
    backgroundTop,
    ApplyInfo,
    ApplyForm,
    ApplyAudit,
    ApplyPay,
    ApplySuccess,
    ApplyPayCheck,
    ApplyPlan,
    CopyRight
  },
  name: 'Apply',
  data() {
    return {
      // step: 0
      loading: true
    }
  },
  created() {
    this.getStatus()
  },
  computed: {
    ...mapState({
      stepIndex: 'stepIndex',
      bianzhi: 'bianzhi',
      signup_id: 'signup_id',
      sign_rec_id: 'recId'
    })
  },
  methods: {
    ...mapMutations({
      setStep: 'SET_STEP',
      setPass: 'SET_PASS',
      setPay: 'SET_PAY',
      setPeyHerf: 'SET_PAYHERF',
      setRecID: 'SET_RECID',
      setFailInfo: 'SET_FAILINFO',
      setDownLoad: 'SET_DOWNLOAD'
    }),
    reload() {
      // this.getStatus()
    },
    getStatus() {
      const url = '/api/signup/stepInfo?' + 'signupId=' + this.$route.query.singupId + '&bianzhi=' + this.$route.query.bianzhi
      const url2 = encodeURI(url)
      this.$axios
        .get(url2)
        .then(result => {
          const { data: res } = result
          console.log('res', res)
          this.loading = false

          if (res.response_code == 503) {
            this.setStep(-1)
            this.$alert('您还未登录或登录已失效请重新登录', '请登录', {
              confirmButtonText: '确定',
              callback: action => {
                this.$router.push('/')
              }
            })
          }
          // 未报名
          if (res.response_code == 201) {
            // this.setGetJobList(true)
            this.setStep(0)
            window.sessionStorage.setItem('state', 201)
          }
          // 已报名，待初审
          if (res.response_code == 210) {
            window.sessionStorage.setItem('state', 210)
            this.setPass(true)
            this.setRecID(res.data.sign_rec_id)
            this.setStep(2)
          }
          // 初审通过，待支付
          if (res.response_code == 211) {
            window.sessionStorage.setItem('state', 211)
            this.setPeyHerf(res.data)
            this.setStep(3)
          }
          // 已支付，待复审
          if (res.response_code == 220) {
            window.sessionStorage.setItem('state', 220)
            this.setStep(4)
          }
          // 复审通过，待考试安排
          if (res.response_code == 221) {
            window.sessionStorage.setItem('state', 221)
            this.setStep(5)
          }
          // 打印准考证
          if (res.response_code == 230) {
            window.sessionStorage.setItem('print_url', res.data.print_url)
            this.setDownLoad(res.data.print_url)
            this.setRecID(res.data.sign_rec_id)
            this.setStep(6)
          }
          // 初审失败
          if (res.response_code == 212) {
            window.sessionStorage.setItem('state', 212)
            this.setFailInfo(res.data.check_result)
            this.setPass(false)
            this.setRecID(res.data.sign_rec_id)
            this.setStep(2)
          }
          // 已支付，复审失败
          if (res.response_code == 222) {
            window.sessionStorage.setItem('state', 222)
            this.setPeyHerf(res.data)
            this.setFailInfo(res.data.check_result)
            this.setPay(false)
            this.setStep(4)
          }
          // 初审已结束
          if (res.response_code == 21001) {
            window.sessionStorage.setItem('state', 21001)
            this.setStep(-1)

            this.$alert(res.response_msg, '初审结束', {
              callback: action => {
                // this.$message({
                //   type: 'info',
                //   message: '请重新登录'
                // })
                this.$router.push('/ApplyHome')
              }
            })
          }
          if (res.response_code == 500) {
            this.$alert(res.response_msg, '', {
              callback: action => {
                this.$router.push('/')
              }
            })
          }
          if (res.response_code == 20102) {
            // this.setGetJobList(false)
            sessionStorage.setItem('state', 20102)
            this.$alert(res.response_msg, '报名截止', {
              callback: action => {
                this.$router.push('/ApplyHome')
              }
            })
          }
          if (res.response_code == 21101) {
            // this.setGetJobList(false)
            sessionStorage.setItem('state', 21101)
            this.$alert(res.response_msg, '支付失败', {
              callback: action => {
                this.$router.push('/ApplyHome')
              }
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.loading = false
          this.$router.push('/ApplyActive')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/style/mixin.scss';

.applyPage {
  overflow: hidden\9;
  min-height: calc(100vh - 180px);
}

.el-steps {
  margin-top: -50px;
  position: absolute\9;
  width: 84%\9;
  // display: hidden;
}

/deep/.is-simple.el-step {
  flex-basis: 20%;
  margin-right: 0px;
  float: left\9;
  margin-right: 20px\9 !important;
  width: 15%\9;
}

/deep/.is-simple.el-step .el-step__arrow {
  align-items: baseline\0;
  display: none\9;
}

/deep/ :not(:last-of-type).is-simple.el-step .el-step__title {
  max-width: 100%\9;
}

/deep/ .el-step__head,
.el-step__main,
.el-step__title,
.el-step__arrow,
.el-step__icon {
  float: left\9;
}

// /deep/ .el-step__main {
//   float: left\9;
// }
/deep/ .el-step__title {
  // float: left\9;
  margin-right: 10px\9;
}

// /deep/ .el-step__arrow {
//   float: left\9;
// }
// /deep/ .el-step__icon {
//   float: left\9;
// }
.stepPage {
  min-height: calc(100vh - 380px);
}
</style>
